<template>
  <ExpandList
    v-if="expandList"
    :key="expandList.paramPage"
    :query-key="expandList.paramPage + index"
    :fetch-method="expandList.fetchMethod"
    :param-page="expandList.paramPage"
    :list-type="expandList.listType"
    :prop-data="widget"
    is-auto-pagination
    class="provider-widgets"
  >
    <template #default>
      <HeadlineAction
        :title="expandList.title"
        :img="expandList.img"
        class="provider-widgets__header"
      />
    </template>
  </ExpandList>

  <WidgetComprehensive
    v-else-if="widgetComprehensiveAttrs"
    v-bind="widgetComprehensiveAttrs"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WidgetComprehensive from '@/components/shared/Widgets/WidgetComprehensive'
import { VIEW_TYPE, LIST_TYPE } from '@/components/Lobby/enum.js'
import { getLangText } from '@/components/Lobby/helpers.js'
import ExpandList from '~/components/Lobby/ExpandList'
import HeadlineAction from '@/components/shared/HeadlineAction'

export default {
  name: 'ProviderWidget',
  components: {
    WidgetComprehensive,
    ExpandList,
    HeadlineAction,
  },
  props: {
    widget: { type: Object },
    index: { type: Number },
    term: { type: String },
  },
  computed: {
    ...mapGetters('lobby', [
      'get_subsectionItem',
    ]),
    expandList() {
      const widget = this.widget
      if (!widget || widget.viewType !== VIEW_TYPE.GRID) return

      if (!widget.games?.result?.length) return

      return {
        fetchMethod: this.fetch_providerItem,
        paramPage: this.term,
        listType: LIST_TYPE.GAME.NAME,
        img: `/img/lobby/provider-slider-${this.index + 1}.svg`,
        title: getLangText(widget.nameUa, widget.nameRu, this.$i18n),
      }
    },
    widgetComprehensiveAttrs() {
      const widget = this.widget
      if (!widget || widget.viewType !== VIEW_TYPE.SLIDER) return

      const list = this.widget.games.result
      if (!list?.length) return
      const title = getLangText(widget.nameUa, widget.nameRu, this.$i18n)
      const img = `/img/lobby/provider-slider-${this.index + 1}.svg`
      const row = 1
      const usesCard = { name: 'CardGame' }

      return {
        list,
        title,
        img,
        row,
        usesCard,
      }
    },
  },
  methods: {
    ...mapActions('lobby', [
      'fetch_providerItem',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.provider-widgets {
  &__header {
    margin-bottom: 16px;

    @include media(tablet) {
      margin-bottom: 24px;
    }
  }
}
</style>
